(function () {
  'use strict';

  window._21eMinerQuizConfig = {
    questions: [
      {
        id: 'goal',
        titleKey: 'q1_title',
        answers: [
          { labelKey: 'q1_a1', emoji: '\uD83C\uDFE0', tags: { quiet: 6, ease_of_use: 4 } },
          { labelKey: 'q1_a2', emoji: '\uD83D\uDCB0', tags: { performance: 7, quiet: -3, ease_of_use: -2 } },
          { labelKey: 'q1_a3', emoji: '\uD83D\uDCB5', tags: { price: 6 } },
          { labelKey: 'q1_a4', emoji: '\uD83C\uDF93', tags: { ease_of_use: 6, price: 4 } }
        ]
      },
      {
        id: 'location',
        titleKey: 'q2_title',
        answers: [
          { labelKey: 'q2_a1', emoji: '\uD83D\uDECB\uFE0F', tags: { quiet: 3 } },
          { labelKey: 'q2_a2', emoji: '\uD83C\uDFD7\uFE0F', tags: { quiet: 1, performance: 1 } },
          { labelKey: 'q2_a3', emoji: '\uD83C\uDFED', tags: { performance: 2 } },
          { labelKey: 'q2_a4', emoji: '\uD83C\uDFE2', tags: { quiet: 2, ease_of_use: 1 } }
        ]
      },
      {
        id: 'budget',
        titleKey: 'q3_title',
        answers: [
          { labelKey: 'q3_a1', emoji: '\uD83D\uDCB5', tags: { price: 3 }, maxEur: 50000 },
          { labelKey: 'q3_a2', emoji: '\uD83D\uDCB6', tags: { price: 2 }, maxEur: 150000 },
          { labelKey: 'q3_a3', emoji: '\uD83D\uDC8E', tags: { price: 1, performance: 1 }, maxEur: 300000 },
          { labelKey: 'q3_a4', emoji: '\uD83C\uDFC6', tags: { performance: 2 }, maxEur: null }
        ]
      },
      {
        id: 'experience',
        titleKey: 'q4_title',
        answers: [
          { labelKey: 'q4_a1', emoji: '\uD83C\uDD95', tags: { ease_of_use: 3 } },
          { labelKey: 'q4_a2', emoji: '\uD83D\uDCDA', tags: { ease_of_use: 1 } },
          { labelKey: 'q4_a3', emoji: '\uD83D\uDD27', tags: { performance: 1 } }
        ]
      },
      {
        id: 'priority',
        titleKey: 'q5_title',
        optional: true,
        answers: [
          { labelKey: 'q5_a1', emoji: '\uD83E\uDD2B', tags: { quiet: 3 } },
          { labelKey: 'q5_a2', emoji: '\uD83D\uDE80', tags: { performance: 2, price: 1 } },
          { labelKey: 'q5_a3', emoji: '\u2705', tags: { ease_of_use: 2, quiet: 1 } }
        ]
      }
    ],

    productProfiles: {
      // ── Ofen 2 Pro ──
      'ofen-2-pro': {
        tags: { quiet: 5, performance: 4, price: 3, ease_of_use: 5 },
        reasons: ['reason_silent', 'reason_heater', 'reason_easy_setup']
      },

      // ── Ofen 2 ──
      'ofen-2': {
        tags: { quiet: 5, performance: 3, price: 4, ease_of_use: 5 },
        reasons: ['reason_silent', 'reason_heater', 'reason_easy_setup']
      },

      // ── Bitmain Antminer S21 200 TH ──
      'bitcoin-antminer-s21': {
        tags: { quiet: 2, performance: 5, price: 3, ease_of_use: 3 },
        reasons: ['reason_top_performance', 'reason_great_value', 'reason_proven']
      },

      // ── Bitmain Antminer S21+ 225 TH ──
      'bitmain-antminer-s21': {
        tags: { quiet: 2, performance: 5, price: 3, ease_of_use: 3 },
        reasons: ['reason_top_performance', 'reason_great_value', 'reason_proven']
      },

      // ── Bitmain Antminer S21 XP 270 TH ──
      'bitmain-antminer-s21-xp': {
        tags: { quiet: 1, performance: 5, price: 1, ease_of_use: 3 },
        reasons: ['reason_top_performance', 'reason_proven', 'reason_easy_setup']
      },

      // ── Bitmain Antminer S21 Pro 234 TH ──
      'bitmain-antminer-s21-pro-234-th': {
        tags: { quiet: 1, performance: 5, price: 2, ease_of_use: 3 },
        reasons: ['reason_top_performance', 'reason_proven', 'reason_easy_setup']
      },

      // ── Bitmain Antminer S21+ Hydro 358 TH ──
      'bitmain-antminer-s21-hydro': {
        tags: { quiet: 3, performance: 5, price: 1, ease_of_use: 1 },
        reasons: ['reason_top_performance', 'reason_liquid_cooled', 'reason_proven']
      },

      // ── Bitmain Antminer S21 XP Hydro 473 TH ──
      'bitmain-antminer-s21-xp-hydro': {
        tags: { quiet: 3, performance: 5, price: 1, ease_of_use: 1 },
        reasons: ['reason_top_performance', 'reason_liquid_cooled', 'reason_proven']
      },

      // ── Bitmain Antminer S19 XP+ Hydro 293 TH ──
      'bitmain-antminer-s19-xp-hydro': {
        tags: { quiet: 3, performance: 5, price: 3, ease_of_use: 1 },
        reasons: ['reason_top_performance', 'reason_liquid_cooled', 'reason_great_value']
      },

      // ── Bitmain Antminer S19k Pro 120 TH ──
      'bitmain-antminer-s19k-pro': {
        tags: { quiet: 2, performance: 4, price: 4, ease_of_use: 3 },
        reasons: ['reason_great_value', 'reason_proven', 'reason_easy_setup']
      },

      // ── Bitmain Antminer S19XP 141 TH ──
      'bitmain-antminer-s19xp-141-th': {
        tags: { quiet: 2, performance: 4, price: 4, ease_of_use: 3 },
        reasons: ['reason_proven', 'reason_great_value', 'reason_top_performance']
      },

      // ── Bitmain Antminer S19 86 TH ──
      'bitmain-antminer-s19-1': {
        tags: { quiet: 2, performance: 3, price: 5, ease_of_use: 3 },
        reasons: ['reason_great_value', 'reason_proven', 'reason_affordable']
      },

      // ── Bitmain Antminer S9 13.5 TH ──
      'bitmain-antminer-s9': {
        tags: { quiet: 2, performance: 1, price: 5, ease_of_use: 3 },
        reasons: ['reason_affordable', 'reason_compact', 'reason_easy_setup']
      },

      // ── Bitmain Antminer S9i 13.5 TH ──
      'bitmain-antminer-s9i': {
        tags: { quiet: 2, performance: 1, price: 5, ease_of_use: 3 },
        reasons: ['reason_affordable', 'reason_compact', 'reason_easy_setup']
      },

      // ── MicroBT Whatsminer M31S+ 80 TH ──
      'microbt-whatsminer-m31s': {
        tags: { quiet: 1, performance: 2, price: 5, ease_of_use: 1 },
        reasons: ['reason_affordable', 'reason_proven', 'reason_great_value']
      },

      // ── MicroBT Whatsminer M60S+ 208 TH ──
      'microbt-whatsminer-m60s-188-th': {
        tags: { quiet: 1, performance: 5, price: 2, ease_of_use: 1 },
        reasons: ['reason_top_performance', 'reason_proven', 'reason_great_value']
      },

      // ── MicroBT Whatsminer M63S+ 440 TH ──
      'microbt-whatsminer-m63': {
        tags: { quiet: 3, performance: 5, price: 1, ease_of_use: 1 },
        reasons: ['reason_top_performance', 'reason_liquid_cooled', 'reason_proven']
      },

      // ── Canaan Avalon Q 90 TH ──
      'canaan-avalon-q': {
        tags: { quiet: 3, performance: 4, price: 3, ease_of_use: 3 },
        reasons: ['reason_easy_setup', 'reason_silent', 'reason_compact']
      },

      // ── Bitaxe 602 Gamma / Nerdaxe Gamma Premium ──
      'bitaxe-602-gamma-premium-edition': {
        tags: { quiet: 5, performance: 1, price: 5, ease_of_use: 3 },
        reasons: ['reason_easy_setup', 'reason_affordable', 'reason_silent']
      },
      'nerdaxe-gamma-premium': {
        tags: { quiet: 5, performance: 1, price: 5, ease_of_use: 3 },
        reasons: ['reason_easy_setup', 'reason_affordable', 'reason_silent']
      },

      // ── Bitdeer Sealminer A2 228 TH ──
      'bitdeer-sealminer-a2-aircooling': {
        tags: { quiet: 1, performance: 5, price: 1, ease_of_use: 1 },
        reasons: ['reason_top_performance', 'reason_proven', 'reason_great_value']
      },

      // ── S9 Silent 12.5 TH ──
      's9-silent': {
        tags: { quiet: 3, performance: 1, price: 5, ease_of_use: 3 },
        reasons: ['reason_silent', 'reason_affordable', 'reason_compact']
      },

      // ── S19k Pro Silent 120 TH ──
      's19-silent': {
        tags: { quiet: 3, performance: 4, price: 3, ease_of_use: 3 },
        reasons: ['reason_silent', 'reason_great_value', 'reason_proven']
      }
    }
  };
})();
